import { EDealType, Filters } from 'shared/types/filters';

export function isRent(filters: Filters): boolean {
  return filters.dealType === EDealType.Rent;
}
